import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'

/** Field IDs gated by the org:contacts:see-utm permission in the contact drawer */
export const UTM_GATED_FIELD_IDS = [
  `content`,
  `GCLID`,
  `FBCLID`,
  `referralURL`,
  `landingPageURL`,
  `reportedAttribution`,
]

/**
 * Determines if UTM/marketing fields (Content, GCLID, FBCLID, Referral URL,
 * Landing Page URL, Reported Attribution) should be visible.
 *
 * Rules:
 * - Non-SMC: always visible
 * - SMC: requires `org:contacts:see-utm` permission (workspace users never have this)
 * - Super users: always visible
 */
export function useShowUtmFields(): boolean {
  const user = useUser()
  const checkPermission = useCheckPermission()

  if (!user) return false
  if (user.type === `super`) return true
  if (!isSMCOrg(user.orgId!)) return true
  return checkPermission(`org:contacts:see-utm`)
}
